// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) {
    $(".embed-bg iframe").each(function () {
        var src = $(this).attr("src");
        if (src && (src.includes("youtube.com") || src.includes("youtu.be"))) {
            if (src.includes("?")) {
                src += "&autoplay=1&mute=1";
            } else {
                src += "?autoplay=1&mute=1";
            }
            $(this).attr("src", src);
            $(this).attr(
                "allow",
                "accelerometer; autoplay; autostop; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            );
            $(this).attr("allowfullscreen", "true");
        }
    });

    let moreBtn = document.querySelector(".social-btn.more i");
    let extraBtns = document.querySelector(".extra-social-buttons");
    if (moreBtn && extraBtns) {
        moreBtn.parentElement.addEventListener("click", function (event) {
            event.preventDefault();
            if (extraBtns.classList.contains("show")) {
                extraBtns.style.height = extraBtns.scrollHeight + "px";
                setTimeout(() => {
                    extraBtns.style.height = "0";
                    extraBtns.classList.remove("show");
                    moreBtn.classList.replace("fa-minus", "fa-plus");
                }, 10);
            } else {
                extraBtns.classList.add("show");
                extraBtns.style.height = extraBtns.scrollHeight + "px";
                setTimeout(() => {
                    extraBtns.style.height = "auto";
                }, 100);
                moreBtn.classList.replace("fa-plus", "fa-minus");
            }
        });
    }
});

const elements = document.querySelectorAll(
    ".cover-with-parallax-detail figure, .cover-with-parallax-detail h1, .cover-with-parallax-detail h2, .cover-with-parallax-detail h3, .cover-with-parallax-detail h4, .cover-with-parallax-detail h5, .cover-with-parallax-detail h6, .cover-with-parallax-detail p, .cover-with-parallax-detail ul"
);
if (elements.length > 0) {
    elements.forEach((element) => {
        element.setAttribute("data-aos", "fade-up");
        element.setAttribute("data-aos-duration", "1000");
    });
}

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

// Detect if the user is navigating with keyboard
function handleFirstTab(e) {
    if (e.key === "Tab") {
        document.body.classList.add("user-is-tabbing");
        window.removeEventListener("keydown", handleFirstTab);
        window.addEventListener("mousedown", handleMouseDownOnce);
    }
}

// Detect if the user switches to using the mouse
function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");
    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}

// Apply focus styles based on keyboard navigation
document.addEventListener("focusin", function (e) {
    if (document.body.classList.contains("user-is-tabbing")) {
        e.target.classList.add("keyboard-focus");
    }
});

document.addEventListener("focusout", function (e) {
    e.target.classList.remove("keyboard-focus");
});

window.addEventListener("keydown", handleFirstTab);
